import * as React from 'react';

// tslint:disable:max-line-length
export const StudioIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g fillRule="nonzero">
      <path d="M14.494 1.6C13.553.6 12.33 0 10.918 0 9.694 0 8.376.6 7.435 1.6c-.94 1-1.506 2.3-1.506 3.8 0 1.4.565 2.8 1.506 3.8.941 1 2.26 1.6 3.577 1.6 1.317 0 2.54-.5 3.576-1.6 1.883-2.2 1.883-5.6-.094-7.6zM6.118 10.5a6.92 6.92 0 0 1-1.6-2.8l-3.389 4.6c-.282.4-.282 1 .095 1.3l1.882 2c.376.4.847.4 1.223.1l4.33-3.6c-.847-.2-1.788-.8-2.541-1.6z" />
    </g>
  </svg>
);
